let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jHFF9")).then(() => parcelRequire('g28T6'));